module.exports = "<h1>WebVR Camera Stream</h1><div>Read about the project <a href=\"https://greenin.space/streaming-video-in-webvr/\">here</a></div><div><a href=# id=stream>Start a new stream</a></div>";
